export enum STORAGE {
  USER          = 'ppsAccess',
  TOKEN         = 'tokenAccess',
  REFRESH_TOKEN = 'refreshToken',
}

export enum ActionForm {
  CREATE = 'create',
  EDIT   = 'edit',
  SHOW   = 'show',
  DELETE = 'delete',
}
